module.exports = new __parcel__URL__("underwater.cfe8fb42.mp4").toString();